<template>
  <AuthView :title="`Order #${id}`">
    <AppRow>
      <div v-if="order">
        <AppRow sequence-two>
          <strong>ID</strong>
          {{ order.id }}

          <strong>Form ID</strong>
          {{ order.form_id }}

          <strong>Branch</strong>
          {{ order.branch }}

          <strong>Payment Method</strong>
          {{ order.payment_processor }}

          <strong>Payment ID</strong>
          {{ order.payment_id }}

          <strong>Amount</strong>
          {{ order.amount }}

          <strong>Currency</strong>
          {{ order.currency }}

          <strong>Status</strong>
          {{ order.status }}

          <strong>Coupon</strong>
          <pre v-if="order.coupon">{{ order.coupon }}</pre>
          <template v-else>—</template>

          <strong>Domain</strong>
          {{ order.domain }}

          <strong>Created at</strong>
          {{ order.created_at }}

          <strong>Updated at</strong>
          {{ order.updated_at }}
        </AppRow>
      </div>

      <div class="actions flex col gap-5">
        <AppBtn :loading prepend-icon="mdi:email" @click="sendEmail">
          Send "application received" to client
        </AppBtn>
        <AppBtn :loading prepend-icon="logos:airtable" @click="createRecord">
          Add Order Record
        </AppBtn>
        <AppBtn :loading prepend-icon="mdi:trash" color="error" @click="del">
          Delete order {{ id }}
        </AppBtn>
      </div>
    </AppRow>
  </AuthView>
</template>

<script setup lang="ts">
import { snackbarInjectionKey } from '~/assets/injection-keys';
import { createOrderRecord, deleteOrder, getOrder, sendConfirmationToClient } from '~/helpers/http';

definePageMeta({ middleware: 'admin' });

const snackbar = inject(snackbarInjectionKey)!;

const id = useRoute().params.order as string;

const order = await getOrder(id);
if (!order) throw new Error('Order not found');
const loading = ref(false);

async function sendEmail() {
  loading.value = true;
  const { id, form_id } = order;
  const success = await sendConfirmationToClient({
    id,
    formId: form_id
  });
  loading.value = false;
  if (success) {
    snackbar.value!.showSuccess('Sent confirmation email to client');
  }
}
async function createRecord() {
  loading.value = true;
  const success = await createOrderRecord(order);
  loading.value = false;
  if (success) {
    snackbar.value!.showSuccess('Created record');
  }
}
async function del() {
  const confirmation = confirm(`Sure you want to delete Order #${order.id} ?`);
  if (!confirmation) return;
  loading.value = true;
  const success = await deleteOrder(order.id);
  loading.value = false;
  if (success) {
    snackbar.value!.showSuccess(`Deleted order #${order.id}`);
  }
  useRouter().back();
}
</script>

<style scoped>
.actions {
  width: fit-content;
}
</style>